module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-11.1598c0be.svg";